export const environment = {
  production: false,
  OAUTH_URL: 'https://oauth.api.nexuscloud.com.br/api',
  API_URL: 'https://astutus.api.nexuscloud.com.br/api',
  DNE_URL: 'https://dne.api.nexuscloud.com.br/api',
  API_URL_CADASTRO: 'https://cadastro.api.nexuscloud.com.br/api',
  API_URL_COMPRAS: 'https://compras.api.nexuscloud.com.br/api',
  API_URL_DOMINIO: 'https://dominio.api.nexuscloud.com.br/api',
  API_URL_ESTOQUE: 'https://estoque.api.nexuscloud.com.br/api',
  API_URL_FINANCEIRO: 'https://financeiro.api.nexuscloud.com.br/api',
  API_URL_VENDAS: 'https://vendas.api.nexuscloud.com.br/api',
  API_URL_PRECOS: 'https://precos.api.nexuscloud.com.br/api',
  API_URL_FISCAL: 'https://fiscal.api.nexuscloud.com.br/api',
  API_URL_SYNC: 'https://sync.api.nexuscloud.com.br/api',
  S3_API_URL: 'https://s3.api.nexuscloud.com.br/api',
  API_URL_REPORT: 'https://report.api.nexuscloud.com.br/api',
  API_URL_BACKUP: 'https://backup.api.nexuscloud.com.br/api',
  API_URL_NOTIFICATION: 'https://notification.api.nexuscloud.com.br/api',
};
